export const topConversationIntentDummyData = {
  data: [
    {
      name: 'SESSION_INTENT_USER_INFORMATION_COLLECTION',
      aggValue: '236',
      values: [],
    },
    {
      name: 'SESSION_INTENT_SERVICE_IDENTIFICATION',
      aggValue: '219',
      values: [],
    },
    {
      name: 'SESSION_INTENT_BOOKING_REQUESTED',
      aggValue: '201',
      values: [],
    },
    {
      name: 'SESSION_INTENT_PROPOSE_AVAILABILITY',
      aggValue: '142',
      values: [],
    },
    {
      name: 'SESSION_INTENT_RESCHEDULING_REQUESTED',
      aggValue: '80',
      values: [],
    },
    {
      name: 'SESSION_INTENT_CANCELLATION_REQUESTED',
      aggValue: '70',
      values: [],
    },
  ],
  aggregates: {
    staffAnswered: '0',
    staffUnanswered: '0',
    followupTasksScheduling: '0',
    followupTasksOthers: '0',
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: '0',
    totalAiThreads: '0',
  },
  summary: [],
};
